'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isFirefox = undefined;
var _memoize = require('lodash/memoize');
var _memoize2 = _interopRequireDefault(_memoize);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
  return Boolean(window.safari);
});